export default "__VITE_ASSET__CGcabELV__"